exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message[data-v-cedc5aa6] {\n  margin-top: 5px;\n}", ""]);

// exports
